import { Chip } from '@mui/material';

import { useT } from '../i18n/LanguageContext';

type LinkStatus = 'PENDING' | 'ACTIVE' | 'DISABLED' | 'REVOKED';

const COLOUR: Record<LinkStatus, 'warning' | 'success' | 'default' | 'error'> = {
  PENDING: 'warning',
  ACTIVE: 'success',
  DISABLED: 'default',
  REVOKED: 'error',
};

/** How a linked e-shop stands: waiting for its token, connected, paused, or revoked for good. */
export const IntegrationStatusChip = ({ status }: { status: LinkStatus }) => {
  const t = useT();

  return (
    <Chip size="small" variant="outlined" color={COLOUR[status]} label={t(`linkStatus.${status}` as const)} />
  );
};
